module.exports = __webpack_public_path__ + "img/ceiling.3aef61a9.png";